import { ListViewHeader } from '@progress/kendo-react-listview';

/**
 * A single list component that wraps Kendo's ListViewHeader component.
 * This component is used to create list headers with various styles.
 * 
 * @component
 * @param {Object} props - properties passed to component.
 * @param {string} props.children - internal items to render within list header.
 * @param {string} props.className - additional CSS classes to apply to list header.
 * @param {string} props.style - inline styles to apply to list header.
 * @returns {JSX.Element}
 * 
 * @see {@link https://www.telerik.com/kendo-react-ui/components/listview | KendoReact ListView Documentation}
 * 
 */
export const ListHeader = ({
  className = '',
  style = {},
  children
}) => {
  return (
    <ListViewHeader
      className={className}
      style={style}
    >
      {children}
    </ListViewHeader>
  );
}